'use client';

import { useState, useEffect } from 'react';
import CustomTable from '../../components/CustomTable';
import { ModalAlert } from '@/components/ModalStyled/Modal';
import { HStack, Button, Text, Input } from '@chakra-ui/react';
import { BoxTitle } from '@/components/BoxTitle';
import ModalRetorno from '../../components/ModalRetorno';

interface TableProps {
  headers: any;
  onDelete: (selectedData: any[]) => void;
  dados: any[];
  valoPesquisa: string;
}

export default function TabelaModeloVeiculo({ headers, onDelete, dados, valoPesquisa }: TableProps) {
  // Estado local para os dados da tabela
  const [tableData, setTableData] = useState(dados);
  // Controle do modal de cadastro
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Estados para os campos do modal
  const [newModelo, setNewModelo] = useState('');
  const [newFabricante, setNewFabricante] = useState('');
  // Estados para o modal de retorno (feedback)
  const [modalRetornoOpen, setModalRetornoOpen] = useState(false);
  const [mensagemRetorno, setMensagemRetorno] = useState('');
  const [tipoRetorno, setTipoRetorno] = useState<'sucesso' | 'erro'>('sucesso');

  useEffect(() => {
    setTableData(dados);
  }, [dados]);

  const handleDeleteRecords = (selectedData: any[]) => {
    const selectedIds = selectedData.map(item => item.id);
    const newData = tableData.filter(item => !selectedIds.includes(item.id));
    setTableData(newData);
    onDelete(selectedData);
    setMensagemRetorno("Modelo de veículo excluído com sucesso!");
    setTipoRetorno("sucesso");
    setModalRetornoOpen(true);
  };

  const handleAddModeloVeiculo = () => {
    if (newModelo.trim() !== '' && newFabricante.trim() !== '') {
      setTableData(prevData => [
        ...prevData,
        { id: prevData.length + 1, modelo: newModelo, fabricanteveiculo: newFabricante, ativo: true },
      ]);
      setNewModelo('');
      setNewFabricante('');
      setIsModalOpen(false);
      setMensagemRetorno("Modelo de veículo adicionado com sucesso!");
      setTipoRetorno("sucesso");
      setModalRetornoOpen(true);
    }
  };

  const handleDataChange = (newData: any[]) => {
    setTableData(newData);
  };

  return (
    <>
      <CustomTable
        headers={headers}
        data={tableData}
        searchValue={valoPesquisa}
        onDelete={handleDeleteRecords}
        onAdd={() => setIsModalOpen(true)}
        onDataChange={handleDataChange}
        addButtonLabel="Adicionar"
        deleteButtonLabel="Excluir"
        showActions={true}
      />

      <ModalAlert
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<Text fontSize="lg" ml={2}>Adicionar Modelo de Veículo</Text>}
        body={
          <>
            <HStack mt={3}>
              <BoxTitle title="Modelo do Veículo">
                <Input
                  placeholder="Adicione o Modelo"
                  value={newModelo}
                  onChange={(e) => setNewModelo(e.target.value)}
                />
              </BoxTitle>
            </HStack>
            <HStack mt={3}>
              <BoxTitle title="Fabricante">
                <Input
                  placeholder="Selecione o Fabricante"
                  value={newFabricante}
                  onChange={(e) => setNewFabricante(e.target.value)}
                />
              </BoxTitle>
            </HStack>
          </>
        }
        footer={
          <Button colorScheme="blue" onClick={handleAddModeloVeiculo}>
            Confirmar
          </Button>
        }
      />

      <ModalRetorno
        isOpen={modalRetornoOpen}
        onClose={() => setModalRetornoOpen(false)}
        mensagem={mensagemRetorno}
        tipo={tipoRetorno}
      />
    </>
  );
}
